export default __webpack_public_path__ + "static/media/PricingCard3.62b18965.png";